import { render, staticRenderFns } from "./authentication-card.vue?vue&type=template&id=5c242d88"
import script from "./authentication-card.vue?vue&type=script&lang=js"
export * from "./authentication-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports